import { productIdFormat, supplierIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const SupplierProductUpdate = z.object({
  productId: productIdFormat.schema,
  supplierProductTitle: z.string().nullable().optional(),
  supplierSku: z.string().nullable().optional(),
  unitCost: z.number().nullable().optional(),
  currency: z.string().nullable().optional(),
});
export type SupplierProductUpdate = z.infer<typeof SupplierProductUpdate>;

export const updateSupplierProducts = {
  name: "updateSupplierProducts" as const,
  input: z.object({
    supplierId: supplierIdFormat.schema,
    updates: z.array(SupplierProductUpdate).min(1),
  }),
  output: z.number().int(),
};
